import { apiUrl } from '../constants/apiConsts';
import fetchRequest from '../utils/request';
import { getHeaders } from './helpers';

export default class TranslateAPI {
  static getSupportedLanguages () {
    let url = `${apiUrl}//content/translate/supported_languages`;
    const request = new Request(url, {
      method: 'GET',
      headers: getHeaders(),
    });
    return fetchRequest(request);
  }
  static getTranslation (target, textToTranslate ) {
    let url = `${apiUrl}/content/translate/text/${target}/text/${encodeURIComponent(textToTranslate)}`;
    const request = new Request(url, {
      method: 'GET',
      headers: getHeaders(),
    });
    return fetchRequest(request);
  }
}
